import classNames from 'classnames';
import { Tag } from 'antd';
import { useSelector } from 'react-redux';
import { getLang } from 'shared/store/selectors/lang.selector';
import { calculateTrendDelta } from 'shared/utils/quality-metrics.utils';
import {
  QualityMetricBox,
  getMetricAriaLabel,
} from 'src/components/quality-metric/quality-metric-box/quality-metric-box';
import { ListItemsNavigator } from 'src/components/common/items-navigator';
import {
  toGroupMetricView,
  useQualityMetricsManagementContext,
} from '../quality-metrics-management.context';
import styles from '../quality-metrics-management.module.scss';

function SidebarItem({ metric, isSelected, onSelect }) {
  const lang = useSelector(getLang('QUALITY_METRIC'));
  const managementLang = useSelector(getLang('QUALITY_METRICS_MANAGEMENT'));

  const view = toGroupMetricView(metric);
  const trend = calculateTrendDelta({ trends: metric.groupTrends, invert: metric.invert });

  return (
    <button
      className={classNames(styles.sidebarItem, { [styles.sidebarItemSelected]: isSelected })}
      onClick={onSelect}
      aria-label={getMetricAriaLabel({ metric: view, trend, lang })}
      aria-current={isSelected ? 'true' : undefined}>
      <QualityMetricBox
        metric={view}
        trend={trend}
        showIcon={false}
        titleClassName={styles.sidebarItemTitle}
      />
      {metric.isHidden && (
        <Tag className={styles.sidebarItemTag} bordered={false}>
          {managementLang.HIDDEN}
        </Tag>
      )}
    </button>
  );
}

/** The metric list — every metric in the organization, hidden ones included. */
export function ManagementSidebar() {
  const { metrics, selectedMetricId, setSelectedMetricId, lang } =
    useQualityMetricsManagementContext();

  return (
    <nav className={styles.sidebar} aria-label={lang.TITLE}>
      <ListItemsNavigator className={styles.sidebarList}>
        {metrics.map(metric => (
          <SidebarItem
            key={metric.id}
            metric={metric}
            isSelected={metric.id === selectedMetricId}
            onSelect={() => setSelectedMetricId(metric.id)}
          />
        ))}
      </ListItemsNavigator>
    </nav>
  );
}
